export const storeProcessTaskTypes = [
  'CLEANING',
  'RECEPTION',
  'LIVRAISON',
  'INVENTORY',
  'CLIENT_RELATION',
] as const
export type StoreProcessTaskType = (typeof storeProcessTaskTypes)[number]

export const storeProcessTaskTypeLabel: Record<StoreProcessTaskType, string> = {
  CLEANING: 'Nettoyage',
  RECEPTION: 'Réception',
  LIVRAISON: 'Livraison',
  INVENTORY: 'Inventaire',
  CLIENT_RELATION: 'Relation client',
}

// Palette par type de tâche « process », source de vérité partagée entre le planning store-app
// (liseré/fond/texte du bloc) et le badge back-office (fond/texte). Figma 10715:56059 : Nettoyage
// bleu, Inventaire vert, Réception ambre, Livraison or clair, Relation client rouge.
// `bar` = liseré gauche, `bg` = fond, `text` = texte/icône.
export const storeProcessTaskTheme: Record<
  StoreProcessTaskType,
  { bar: string; bg: string; text: string }
> = {
  CLEANING: { bar: '#3E7CB1', bg: '#E4EDF3', text: '#3E7CB1' },
  INVENTORY: { bar: '#6A9560', bg: '#E4EDDB', text: '#4F6A47' },
  RECEPTION: { bar: '#E08A2E', bg: '#FBEFD9', text: '#B96E1B' },
  LIVRAISON: { bar: '#F0A945', bg: '#FEF4E1', text: '#B8801F' },
  CLIENT_RELATION: { bar: '#E5686E', bg: '#FBE0E0', text: '#D0454B' },
}
